import { IReduxAction } from '~/services/interfaces/common-interface';
import {
  SET_LOADING_DATA,
  SET_PAGE,
  SET_ROWS_PER_PAGE,
  SET_ROWS_COUNT,
  SET_ROWS_ORIENTATION,
  SET_ORDER,
  SET_ORDERBY,
  SET_SWITCHES_FILTERS,
  GET_LIST_PRODUCT_SUCCESS,
  SEARCH
} from './product-list-constants';
import { ProductStateInterface } from './product-list-interface';

const INITIAL_STATE: ProductStateInterface = {
  loadingData: false,
  loadingSend: false,
  form: {
    data: null,
    errors: [],
    selects: null
  },
  list: {
    hasRemotePagination: true,
    allRows: [],
    rows: [],
    decimals: 2,
    rowsCount: 0,
    page: 0,
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 25, 50, 100],
    rowsOrientation: 'column',
    rowsOrientationOptions: ['column', 'list', 'listWithOutImage'],
    selected: [],
    selectedCount: 0,
    onlyWithStock: true,
    onlyWithPromotion: false,
    clientMix: false,
    order: 'desc',
    orderBy: 'name'
  }
};

const productReducer = (state: any = { ...INITIAL_STATE }, action: IReduxAction) => {
  switch (action.type) {
    case SET_LOADING_DATA: {
      return {
        ...state,
        loadingData: action.loading
      };
    }

    case GET_LIST_PRODUCT_SUCCESS: {
      return {
        ...state,
        list: {
          ...state.list,
          rows: action.payload?.products,
          allRows: action.payload?.products,
          rowsCount: action.payload?.rowsCount ?? state?.list?.rowsCount,
          decimals: action.payload?.decimals
        }
      };
    }

    case SET_PAGE: {
      return {
        ...state,
        list: {
          ...state.list,
          page: action.page
        }
      };
    }

    case SET_ROWS_PER_PAGE: {
      return {
        ...state,
        list: {
          ...state.list,
          rowsPerPage: action.rowsPerPage
        }
      };
    }

    case SET_ROWS_COUNT: {
      return {
        ...state,
        list: {
          ...state.list,
          rowsCount: action.rowsCount
        }
      };
    }

    case SET_ROWS_ORIENTATION: {
      return {
        ...state,
        list: {
          ...state.list,
          rowsOrientation: action.rowsOrientation
        }
      };
    }

    case SET_ORDER: {
      return {
        ...state,
        list: {
          ...state.list,
          order: action.order
        }
      };
    }

    case SET_ORDERBY: {
      return {
        ...state,
        list: {
          ...state.list,
          orderBy: action.orderBy
        }
      };
    }

    case SET_SWITCHES_FILTERS: {
      const { name, value } = action.payload;

      return {
        ...state,
        list: {
          ...state.list,
          [name]: value
        }
      };
    }

    case SEARCH: {
      const { queryText } = action;

      const results =
        queryText !== ''
          ? state.list.allRows.filter(
              (item: any) =>
                item?.name?.toLowerCase().startsWith(queryText.toLowerCase()) ||
                item?.barCode?.toLowerCase().startsWith(queryText.toLowerCase()) ||
                item?.brand?.toLowerCase().startsWith(queryText.toLowerCase()) ||
                item?.stock?.availableQuantity?.toString().startsWith(queryText)
            )
          : state.list.allRows;

      return {
        ...state,
        list: {
          ...state.list,
          rows: [...results]
        }
      };
    }

    default:
      return state;
  }
};

export default productReducer;
